export const YM_COUNTER_ID = 29276100;
